var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartPie, SumLegend } from '../svg-elements/module';
import { parseForPieV2 } from "../d3-services/data.functions";
import { GraphControllerV2 } from "./graph-v2";
// const config : IGraphConfigV2=   {
//     "extra" :{
//         "currencyLabels" : false,
//         "legendWidth" : 220,
//         "maxRadius" : 100,
//         "innerRadius" : 20,
//     }
// };
var PieChartSumV2 = /** @class */ (function (_super) {
    __extends(PieChartSumV2, _super);
    function PieChartSumV2(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    PieChartSumV2.prototype.pre = function () {
        this._addMargin(0, 15, 0, 0);
        this._addPadding(0, 0, 0, 0);
        this.config.extra.municipalitySelect = false;
        this.config.extra.maxRadius = 100;
        this.config.extra.innerRadius = 20;
    };
    PieChartSumV2.prototype.init = function () {
        var self = this;
        // create extra div to house graph -- so that legend does not influence height of graphContainer
        _super.prototype._init.call(this);
        var svgId = "pie-element-" + this.mapping.slug;
        var flowEl = document.createElement('div');
        flowEl.id = svgId;
        flowEl.style.width = '100%';
        flowEl.style.height = "260px"; // radius = 90 
        this.element.appendChild(flowEl);
        _super.prototype._svg.call(this, flowEl);
        this.config.extra.legendWidth = this.dimensions.width > 240 ? 240 : this.dimensions.width;
        this.chartPie = new ChartPie(this);
        this.legend = new SumLegend(this);
        if (this.data[0][this.firstMapping['column']] != null) {
            this.update(this.data, this.segment, false);
        }
    };
    PieChartSumV2.prototype.prepareData = function (data) {
        var slice = parseForPieV2(this.config, this.mapping, "all", data);
        return {
            latest: null,
            slice: slice,
            history: null
        };
    };
    PieChartSumV2.prototype.draw = function (data) {
        this.legend.draw(data);
        if (data[2] && data[2][0]) {
            var clonedData = JSON.parse(JSON.stringify(data));
            clonedData[0].unshift(clonedData[2][0]);
            this.chartPie.draw(clonedData[0]);
        }
        else {
            this.chartPie.draw(data.slice);
        }
    };
    PieChartSumV2.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        this.legend.redraw(data.slice);
        this.chartPie.redraw();
    };
    PieChartSumV2.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return PieChartSumV2;
}(GraphControllerV2));
export default PieChartSumV2;
